import {SetUpStep} from 'src/openapi/admin/models/SetUpStep';

import type {SsoDraftStepFunnelStatistic} from 'src/openapi/admin/models/SsoDraftStepFunnelStatistic';

export const FUNNEL_STEPS = [
    {label: 'Get Started', step: SetUpStep.START_STEP},
    {label: 'Select IdP', step: SetUpStep.SELECT_IDP},
    {label: 'Verify Domain', step: SetUpStep.VERIFY_DOMAIN},
    {label: 'Download SP Metadata', step: SetUpStep.SP_METADATA},
    {label: 'Provide User Attributes', step: SetUpStep.USER_ATTRIBUTES},
    {label: 'Upload IdP Metadata', step: SetUpStep.IDP_METADATA},
    {label: 'Test End User', step: SetUpStep.TEST_CONNECTION},
    {label: 'Review & Enforce', step: SetUpStep.REVIEW_AND_ENFORCE},
] as const;

export const buildStepFunnelChartData = (statistics: SsoDraftStepFunnelStatistic[]) => FUNNEL_STEPS.map(
    ({label, step}) => {
        const statistic = statistics.find(item => item.step === step);
        const reachedCount = statistic?.reachedCount ?? 0;

        return {
            label,
            value: reachedCount,
            toolText: `${label}: ${reachedCount}`
                + (statistic?.reachedPercent == null ? '' : ` (${statistic.reachedPercent.toFixed(1)}%)`),
        };
    },
);
